import {Component} from "preact";
import JWTClient from "../../../../services/JWTClient";
import NotificationsButton from "../sections/notification/notifications-button";
import Spinner from "../../../common/spinner";
import SectionComponent from "../../../layout/section-component";
import ProfileButton from "../sections/user/profile-button";
import ToolbarButton from "../../../common/toolbar-button";
import MessengerButton from "../sections/messenger/messenger-button";
import ChatButton from "../sections/chat/chat-button";
import ConfigService from "../../../../services/ConfigService";
import JsonApiDeserializer from "../../../../services/JsonApiDeserializer";
import {translate} from "../../../../services/TranslateService";
import AccountOff from 'mdi-preact/AccountOffIcon';
import HelpDeskButton from "../sections/help-desk/help-desk-button";
import SubBar from "../sections/sub-bar";
import ModuleInfoProvider from "../../../../services/ModuleInfoProvider";

export default class UserMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: false,
        };
    }

    static defaultProps = {
        organigrammaServerUrl: ''
    };

    render(props) {
        const spinner = () => <ToolbarButton disabled={true}><Spinner/></ToolbarButton>;
        const profile = ConfigService.userProfile();
        const profileIsDefined = profile && Object.keys(profile).length;
        const messengerIsEnabled = ModuleInfoProvider.isEnabled('messenger');
        const chatIsEnabled = ModuleInfoProvider.isEnabled('chat');

        const retryButton = () => (!this.state.loading && !profileIsDefined) ? (
            <SectionComponent>
                <ToolbarButton type={'text'} onClick={this.fetchProfile} title={translate('action.retry')}>
                    <AccountOff/>
                </ToolbarButton>
            </SectionComponent>
        ) : null;

        const children = () => (!this.state.loading && profileIsDefined) ? [
            <NotificationsButton/>,
            <SubBar>
                {messengerIsEnabled ? <MessengerButton/> : null}
                {chatIsEnabled ? <ChatButton/> : null}
                <HelpDeskButton/>
                <ProfileButton/>
            </SubBar>
        ] : null;

        return (
            <SectionComponent>
                {(this.state.loading) ? spinner() : null}
                {retryButton()}
                {children()}
            </SectionComponent>
        );
    }

    componentDidMount() {
        this.fetchProfile();
    }

    fetchProfile() {
        this.setState({loading: true, error: false});
        Promise.all([
            JWTClient.fetch(this.props.organigrammaServerUrl + '/profile').then(res => {
                ConfigService.userProfile(JsonApiDeserializer.deserializeItem(res.data, res.included));
            }),
            JWTClient.fetch(this.props.organigrammaServerUrl + '/profile/domain-actions').then(res => {
                ConfigService.domainActions(res.data.map(i => i.name));
            })
        ])
            .then(() => this.setState({loading: false, error: false}))
            .catch((e) => {
                console.log(e);
                this.setState({loading: false, error: true, profile: {}});
            });
    }
}






// WEBPACK FOOTER //
// ./components/sections/personal-area/user-menu/index.js